import { posDisplaySize } from '../../../settings'

export const sectionStyles = {
  wrap: {
    width: posDisplaySize.width,
    height:
      posDisplaySize.width * posDisplaySize.ratio -
      (posDisplaySize.headerHeight + posDisplaySize.footerHeight),
    position: 'absolute',
    top: posDisplaySize.headerHeight,
  },
}